import { EligibilityToolSettings } from './EligibilityToolSettings'

export default EligibilityToolSettings
